"use client";

import { useState } from "react";

import { cn } from "@/lib/utils";

// Wordmark dourado de fallback (caso /logo.png não exista ainda)
function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn("font-bold tracking-tight", className)}
      style={{
        background: "linear-gradient(135deg,#caa24a 0%,#f4d784 45%,#caa24a 100%)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      XPR LeadOS
    </span>
  );
}

// Logo em imagem (/logo.png) com fallback pro wordmark
export function Logo({
  className,
  height = 40,
}: {
  className?: string;
  height?: number;
}) {
  const [err, setErr] = useState(false);
  if (err) return <Wordmark className={cn("text-2xl", className)} />;
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/logo.png"
      alt="XPR LeadOS"
      height={height}
      style={{ height }}
      className={cn("w-auto rounded-lg object-contain", className)}
      onError={() => setErr(true)}
    />
  );
}

export { Wordmark };
